import moment from 'moment'

export default function (value) {
    if (value === undefined || value === null)
        return ''

    return moment(value).calendar()
}